import React, { useLayoutEffect, useState } from 'react';
import BetsOddsHeader from '../../common/BetsOddsHeader';
import MessageInfo from '../../common/MessageInfo';
import Img from '../../common/util/Img';
import { classIf, filterBetsByNumberOfOdds, filtraParametriche } from '../../data/utils';
import { getLabel } from '../../InitData';
import { adjustOddsAlignment } from '../../tables-utils';
import PrematchTournamentMatch from '../prematch-home/PrematchTournamentMatch';
import PrematchContext from '../../contexts/PrematchContext';

function LastMinutePanel(props) {
    const prematchContext = React.useContext(PrematchContext);
    const [selectedSport, setSelectedSport] = useState(props.sports[0]);

    //props.matchesBySport[selectedSport].forEach(element => element.gruppiScommessa[0].scommesse = element.gruppiScommessa[0].scommesse.slice(0,1));
    const matches = props.matchesBySport[selectedSport];

    let scommesse = matches?.[0]?.gruppiScommessa?.[0]?.scommesse;
    if (scommesse) {
        scommesse = filtraParametriche(scommesse);
        scommesse = filterBetsByNumberOfOdds(scommesse);
    }
   
    useLayoutEffect(() => {
        adjustOddsAlignment();
    });

    if (!scommesse) {
        return (
            <div className="tab-pane fade show active" id="scheda-top-match-2" role="tabpanel">
                <MessageInfo message={getLabel('prematch_page.widget.last_minute') + ' ' + getLabel('general.chiuso')} />
            </div>
        );
    }

    return (
        <div className="tab-pane fade show active" id="scheda-top-match-2" role="tabpanel">
            <div className="titolo-blocco-sport last-minute-t bg-nero bianco">
                <p className="nome-partita-sport">{getLabel('prematch_page.widget.last_minute')}</p>
                <div className="elenco-sport-box-dx">
                    {props.sports.map((sport, i) => {
                        function handleClick() {
                            setSelectedSport(sport);
                        }
                        return <Img key={i}
                                    src={`/assets/img/sport/icone-sport-flat/${sport}.svg`}
                                    alt=""
                                    className={"img-fluid margine-dx-mezzo pointer" + classIf(selectedSport === sport, 'attivo')}
                                    height="30px"
                                    width="30px"
                                    onClick={handleClick} />
                    })}
                </div>
            </div>
            <div className="blocco-quote-espanse">
                <div className="contenitore-table bg-bianco collapse show bordo-tondo" id="tabella-c">
                    <div className="contenitore-table bg-bianco collapse show bordo-tondo">
                        <div className="tabellaQuoteIntestazione text_s1 tabellaQuoteIntestazionePrematch mb-2">
                            <div className="tabellaQuoteAlias d-flex justify-content-center align-items-center">{getLabel('prematch_page.torneo.tournament_day_header.alias')}</div>
                            <div className="tabellaQuoteTempo d-flex justify-content-center align-items-center">
                                <p>{getLabel('prematch_page.torneo.tournament_day_header.time')}</p>
                            </div>
                            <div className="tabellaQuoteSquadre"></div>
                            <div className="tabellaQuoteContenitoreQuotazioni d-flex justify-content-end align-items-center flex-grow-1">
                                <BetsOddsHeader bets={scommesse} />
                            </div>
                            <div className="tabellaQuoteStatistiche"></div>
                            <div className="tabellaQuoteAltre"></div>
                        </div>
                        {matches.map(function(match) {
                            function handleClick() {
                                const tournamentUniqueId = `${match.sportRef}_${match.categoryRef}_${match.tournamentRef}`;
                                prematchContext.openEvent(tournamentUniqueId, match);
                            }

                            return (
                                <PrematchTournamentMatch key={match.id} match={match} aggregata={props.aggregata} isLive={false} openMatch={handleClick} isLastMinute={true} />
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LastMinutePanel;
